<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'disaster', label: '재해형태' }, { type: 'alert', label: '알림 대상자 선택' },]" />

    <!-- 안전검사 대상 기계·기구 종류 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot" /> 안전검사 대상 기계·기구 종류</h5>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-2 flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
          <div v-if="isPrint || board.readonly" class="flex">
            <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            {{ checkbox.title }}
          </div>
          <label v-else class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
            {{ checkbox.title }}
          </label>
        </div>
      </div>
    </div>

    <TableInspectMerge
      v-for="(inspection, indexRows) in form.inspectList"
      :key="indexRows"
      v-show="inspection.check"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="inspection.title"
      tableHeaderTitle="안전검사 주기"
      :tableHeaderCheck="[{ text: '양호' }, { text: '미흡' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '비고' }]"
      v-model="inspection.list"
      class="mt-28px"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    PhotoUploadGridModule,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    'form.inspectList': {
      immediate: true,
      deep: true,
      handler(value) {
        this.checkForm();
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        typeTitleList: [],
        inspectList: [
          {
            check: false,
            title: "크레인(이동식 제외)",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(건설현장에서 사용하는 것은 최초로 설치한 날로부터 6개월마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "리프트(이삿짐운반용 제외)",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(건설현장에서 사용하는 것은 최초로 설치한 날로부터 6개월마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "곤돌라",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(건설현장에서 사용하는 것은 최초로 설치한 날로부터 6개월마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "이동식 크레인",
            list: [
              {
                content: "자동차관리법 제8조에 따른 신규등록 이후 3년 이내에 최초안전검사를 실시하되, 그 이후로부터 2년마다 실시",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "이삿짐운반용 리프트",
            list: [
              {
                content: "자동차관리법 제8조에 따른 신규등록 이후 3년 이내에 최초안전검사를 실시하되, 그 이후로부터 2년마다 실시",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "고소작업대",
            list: [
              {
                content: "자동차관리법 제8조에 따른 신규등록 이후 3년 이내에 최초안전검사를 실시하되, 그 이후로부터 2년마다 실시",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "압력용기",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "프레스",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "전단기",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "롤러기",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "사출성형기",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "원심기",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "국소배기장치",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "컨베이어",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "산업용 로봇",
            list: [
              {
                content: "사업장에 설치가 끝난 날로부터 3년 이내에 최초 안전검사를 실시하되, 그 이후로부터 2년마다 실시(공정안전보고서를 제출하여 확인을 받은 입력용기는 4년마다 실시)",
                isChecked: "",
              },
            ],
          },
        ],
        photoList: [],
        fileList: [],
      },
    };
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.title);
        }
      }
      console.log("this.form.typeTitleList", this.form.typeTitleList)
    },
  },
};
</script>

<style scoped lang="scss"></style>
